module.exports = __webpack_public_path__ + "media/images/partner/supporter/schenklokal_koeln-cf0ccc4ceb608bf0c9707cefcbdbd370.png";